import { GroupV1PortInStatuses } from './states'

export type Message = {
  type: 'info' | 'alert' | 'error'
  message: string
}

export type CodeType = 'pac' | 'stac'

export type PacOrStacData = {
  availableDates: Date[]
  expiryDate: string
  messages: Message[]
  requestActivationBy: string
}

export enum PortInStatuses {
  PORT_REQUESTED = 'port_requested',
  PORT_SUCCESS = 'port_success',
  PORT_FAILURE = 'port_failure',
  PORT_CANCELLED = 'port_cancelled', // we might have it triggered by Mobile app
  MAYBE_PORT_AFTER_ORDER = 'maybe_port_after_order', // order placed with port-in details, but
  // activation occurs when PAC already not valid
}

export interface PortInDetails {
  id: string
  code: string
  code_type: CodeType
  code_expiration: string | null
  requested_portin_date: string | null
  new_msisdn: string
  status: PortInStatuses | GroupV1PortInStatuses
  created_at: string
  submitted_at: string | null
  completed_at: string | null
  expected_completion_date: string
}
